"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateField = exports.TimeField = exports.CalendarField = void 0;

require("./CalendarField.css");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
    Calendar
    
    The calendar component. 
    Handles the time- and date field

    Verified by: Yorben Verhoest
    Date: 05/12/2019
    identityBuilding bvba
    https://identitybuilding.be
*/
// Returns both time and date together
var CalendarField = function CalendarField(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "calendar"
  }, /*#__PURE__*/_react["default"].createElement(TimeField, props), /*#__PURE__*/_react["default"].createElement(DateField, props));
}; // Returns only the time field


exports.CalendarField = CalendarField;

var TimeField = function TimeField(props) {
  return /*#__PURE__*/_react["default"].createElement("input", {
    className: "inputField calendarTime ".concat(props.template ? "temp_".concat(props.template) : ''),
    disabled: props.disabled ? true : false,
    onChange: function onChange(e) {
      return props.onChangeTime(e);
    },
    placeholder: props.placeholder_time,
    type: "time",
    value: props.value_time,
    "aria-label": props.label
  });
}; // Returns only the date field


exports.TimeField = TimeField;

var DateField = function DateField(props) {
  return /*#__PURE__*/_react["default"].createElement("input", {
    className: "inputField calendarDate ".concat(props.template ? "temp_".concat(props.template) : ''),
    disabled: props.disabled ? true : false,
    onChange: function onChange(e) {
      return props.onChangeDate(e);
    },
    placeholder: props.placeholder_date,
    type: "date",
    value: props.value_date,
    "aria-label": props.label
  });
};

exports.DateField = DateField;